import React, { useCallback } from "react";
import { useNavigate, useLocation } from "react-router-dom";

export default function PincodeFoodTypeStatus() {
  const navigate = useNavigate();
  const location = useLocation();
  const { result } = location.state || {};

  const handleBack = () => {
    navigate("/register/pincode");
  };

  const handleProceed = useCallback(() => {
    navigate("/register/form", {
      state: {
        verifiedPincode: result?.pincode,
        pincodeStatus: result?.status,
        pincodeMessage: result?.message,
        lockPincode: true,
      },
    });
  }, [navigate, result]);

  return (
    <div className="flex flex-col items-center justify-center min-h-[80vh] px-3 sm:px-4 relative">
      <button
        onClick={handleBack}
        className="absolute left-0 flex items-center gap-2 font-semibold text-gray-600 transition top-4 sm:left-4 hover:text-red-700"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M19 12H5M12 19l-7-7 7-7"></path>
        </svg>
        <span>Back</span>
      </button>
      
      <div className="w-full max-w-2xl p-4 bg-white border-t-4 border-red-500 shadow-xl sm:p-6 rounded-2xl">
        <h1 className="text-lg font-bold text-center text-red-600 sm:text-2xl">Delivery Availability</h1>
        <p className="mt-2 text-sm text-center text-gray-700 sm:text-base">
          Please review the message before continuing to registration.
        </p>

        {/* Status Message */}
        <div
          className={`mt-4 sm:mt-5 p-3 sm:p-4 rounded-lg border ${
            result?.status === "Allowed" ? "bg-green-50 border-green-300" : "bg-yellow-50 border-yellow-300"
          }`}
        >
          <p className="mt-1 text-xs text-gray-700 sm:text-sm">{result?.message}</p>
        </div>

        {/* Proceed Button */}
        <button
          type="button"
          onClick={handleProceed}
          className={`w-full py-2.5 sm:py-3 mt-4 sm:mt-6 font-bold text-white rounded-lg hover:opacity-90 transition-opacity ${
            result?.status === "Allowed" ? "bg-green-500" : "bg-red-500"
          }`}
        >
          {result?.status === "Allowed" ? "Proceed to Sign Up" : "Click to Proceed"}
        </button>
      </div>
    </div>
  );
}
